import './App.css';

import NavBar from './Components/NavBar/NavBar';
import Hero from './Components/Hero/Hero';
import Footer from './Components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Hero />
      <Footer />
    </div>
  );
}

export default App;
